import { useCallback } from "react";
import { useKeyboardShortcut } from "./useKeyboardShortcut";

export const useClipboardCopy = (options?: {
  text?: string;
  onSuccess?: (text: string) => void;
  onFailure?: (text: string) => void;
  key?: string;
}) => {
  const copy = useCallback(
    async (otherText?: string) => {
      const copyText = otherText ?? options?.text;
      if (copyText === undefined) {
        return false;
      }
      const successed = await navigator?.clipboard
        ?.writeText(copyText)
        .then(() => true)
        .catch(() => false);
      if (successed) {
        options?.onSuccess?.(copyText);
      } else {
        options?.onFailure?.(copyText);
      }
      return successed;
    },
    [options],
  );

  useKeyboardShortcut(options?.key, copy);
  return copy;
};
